import React, {useEffect, useState} from "react";
import {
    MC_ANSWER_LENGTH,
} from "../../utils/constants";
import {stripHTMLTags} from "../../utils/helpers";
import {
    updateRankingAnswers
} from "../../utils/questionUpdate";
import "../styles.css";
import {EditorContent, useEditor} from "@tiptap/react";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import CharacterCount from "@tiptap/extension-character-count";
import TiptapClasses from "../../components/Tiptap/Tiptap.module.css";
import {ReactComponent as TOGGLE} from "../../images/font_gray.svg";
import {ReactComponent as DRAG} from "../../images/drag_flat_grey.svg";
import {ReactComponent as DELETE} from "../../images/trash_red.svg";
import {Color} from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import Highlight from "@tiptap/extension-highlight";
import classes from "../questions.module.css";
import {TipTapMenuBarNew} from "../../components/Tiptap/TipTapMenuBarNew";
import {Draggable} from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";

export default function RKQuestionOptionNew({
                                                optionData,
                                                selectedQuestion,
                                                questions,
                                                setQuestions,
                                                index,
                                                maxSize,
                                                questionBuilder = false,
                                                disabled = false,
                                                warningShowed,
                                                setWarningShowed,
                                                collapsed,
                                                setCollapsed,
                                                deleteCollapsed,
                                            }) {
    const { t } = useTranslation();

    const {choice, optionValue} = optionData;
    const {serialNo, } = selectedQuestion;
    const selectedQuestionIndex = serialNo - 1;

    const editor = useEditor({
        shouldRerenderOnTransaction: true,
        editorProps: {
            transformPastedHTML(text) {
                return stripHTMLTags(text);
            },
        },
        extensions: [
            Underline,
            StarterKit,
            Placeholder.configure({
                placeholder: t("accessibility.optionLabel") + " " + (choice + 1),
            }),
            CharacterCount.configure({limit: MC_ANSWER_LENGTH}),
            TextStyle,
            Color,
            Highlight,
            // Mathematics.configure({
            //   regex: LATEX_REG_EXP,
            // }),
        ],
        onUpdate: ({editor}) => {
            handleAnswerChange(editor.getHTML(), choice);
        },
        content: optionValue,
    }, [serialNo]);

    useEffect(() => {
        if (optionValue !== editor.getHTML()) {
            editor.commands.setContent(optionValue);
        }

    }, [optionValue, editor]);


    const handleAnswerChange = (input, itemKey) => {
        setQuestions(
            updateRankingAnswers(input, itemKey, selectedQuestionIndex, questions)
        );
    };


    const handleDeleteOption = () => {
        let newQuestions = [];

        questions.forEach((q) => {
            if (q.serialNo === serialNo) {
                let newOptionsMap = [];
                q.optionsMap.map((value, index) => {
                    if (index !== choice) {
                        if (index > choice) {
                            const newIndex = index - 1;
                            newOptionsMap[newIndex] = value;
                        } else {
                            newOptionsMap[index] = value;
                        }
                    }
                });
                let updatedQuestion = {
                    ...q,
                    optionsMap: newOptionsMap,
                };
                // updatedQuestion["image" + choice] = null;
                newQuestions.push(updatedQuestion);
            } else {
                newQuestions.push({...q});
            }
        });

        deleteCollapsed();
        setQuestions(newQuestions);
    };


    const renderIndexAndImage = (dragHandleProps) => {
        return (
            <>
            <span {...dragHandleProps} style={{marginLeft: 12}}>
                <DRAG/>
            </span>
                <span className={classes.optionIndex}>
                {index + 1}
            </span>
            </>
        );
    }

    const renderOptionManageBar = () => {
        return (
            <div style={{display: "flex", gap: 5, alignItems: "center", paddingRight: 12}}>
                <span
                    tabIndex={0}
                    style={{cursor: "pointer",}}
                    title={t("poll.toggleMenuBarText")}
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <TOGGLE/>
                </span>
                <span className={classes.iconDivider}/>
                <span
                    tabIndex={0}
                    style={{cursor: "pointer",}}
                    title={t("accessibility.deleteOptionButtonPrefix")}
                    onClick={handleDeleteOption}
                >
             <DELETE/>
          </span>
            </div>
        );
    }


    return (
        <Draggable
            draggableId={`${index}`}
            index={index}
            key={index}
            isDragDisabled={questionBuilder}
        >
            {(provided) => (
                <div
                    tabIndex={-1}
                    className={classes.optionBarWrapper}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                >

                    <div className={classes.optionBar}>
                        {!!collapsed && renderIndexAndImage(provided.dragHandleProps)}

                        <span className={classes.optionEditorWrapper}>
                            <div className={`${classes.optionEditorMenuBar} ${collapsed ? classes.collapsed : ""}`}>
                                <TipTapMenuBarNew
                                    isOpen={!collapsed}
                                    editor={editor}
                                    selectedQuestion={selectedQuestion}
                                />
                                {!collapsed && renderOptionManageBar()}
                            </div>

                            <div style={{display: "flex", gap: 10, alignItems: "center"}}>
                                {!collapsed && renderIndexAndImage(provided.dragHandleProps)}
                                <EditorContent
                                    editor={editor}
                                    style={{cursor: "text", flex: 1, minWidth: 0, height: "100%", paddingRight: collapsed ? 10 : undefined}}
                                    className={`${TiptapClasses.editorContentBox} ${collapsed ? TiptapClasses.noneOutLine : ""}`}
                                />
                            </div>

                            {(!collapsed || (!!editor.isFocused && editor.storage.characterCount.characters() > 0)) &&
                                <span className={`${classes.characterCountBox} ${collapsed ? classes.inline : ""}`}>
                                    {collapsed
                                        ? editor.storage.characterCount.characters()
                                        : `${editor.storage.characterCount.characters()}/${MC_ANSWER_LENGTH}`
                                    }
                                </span>
                            }

                        </span>
                        {!!collapsed && renderOptionManageBar()}
                    </div>
                </div>
            )}
        </Draggable>
    );
}